import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ValidationController, ValidationRules, Validator } from 'aurelia-validation';
import { AsyncErrorHandler } from 'lib/ui';
import { WeldingMachineDto } from 'models/pen/WeldingMachine';
import { WeldingMachineService } from 'services/pen/welding-machine-service';

@autoinject
export class WeldingMachineCreate {
  constructor(
    private dialogController: DialogController,
    private validationController: ValidationController,
    private weldingMachineService: WeldingMachineService,
    private validator: Validator,
    private t: I18N
  ) {}

  protected form: WeldingMachineDto = new WeldingMachineDto();

  attached() {
    this.applyValidationRules();
  }

  protected applyValidationRules() {
    ValidationRules.ensure('Manufacturer')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('MachineNumber')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Model')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .on(this.form);
  }

  @AsyncErrorHandler
  async createWeldingMachine() {
    const valid = await this.validate();
    if (!valid) return;
    this.form.Active = true;
    await this.weldingMachineService.post(this.form);
    await this.dialogController.cancel();
  }

  @AsyncErrorHandler
  async validate() {
    await this.validator.validateObject(this.form);
    return (await this.validationController.validate({ object: this.form })).valid;
  }
}
